export default __webpack_public_path__ + "static/media/allergies.b2868f80.svg";